export default "__VITE_ASSET__7cbfae47__"